module.exports = __webpack_public_path__ + "static/media/NCP_titlePage.c94ac28d.png";